import * as React from 'react';
import PropTypes from 'prop-types';

import EventTracking, {
  getEventScreenName,
  getEventElementName,
  getEventContextName,
  getEventProperties,
} from 'lib/EventTracking';
import createChainedFunction from 'utils/createChainedFunction';
import { RouterState } from 'lib/ReactRouterTypes';

type Props = {
  eventKey?: string;
  eventElementName?: string;
  eventScreenName?: string;
  eventProperties?: Object;
  children: React.ReactElement | React.ReactElement[];
};

type Context = {
  router: RouterState;
  eventProperties?: Object;
  eventContextName?: string;
};
// Dangerous because this should only be used if the component has the correct context types.
export const dangerouslyTrackTapFromComponentInstance = (
  component:
    | React.Component<Props>
    | { props: { eventProperties?: Object; eventKey?: string }; context: any },
  eventPropProperties?: Object
) => {
  const elementName = getEventElementName(component.props);
  const screenName = getEventScreenName(component.props, component.context.router);
  if (elementName && screenName) {
    EventTracking.tap(
      screenName,
      elementName,
      getEventContextName(component.props, component.context),
      getEventProperties(component.props.eventProperties, component.context)
    );
  }

  if (component.props.eventKey) {
    EventTracking.trackKey(component.props.eventKey, component.props.eventProperties);
  }
};

class ClickEventTrigger extends React.PureComponent<Props> {
  static contextTypes = {
    eventScreenName: PropTypes.string,
    eventProperties: PropTypes.object,
    eventContextName: PropTypes.string,
    router: PropTypes.object,
  };

  render(): React.ReactElement {
    const child: React.ReactElement = React.Children.only(this.props.children);
    return React.cloneElement(child, {
      ...child.props,
      onClick: createChainedFunction(
        () => dangerouslyTrackTapFromComponentInstance(this),
        child.props.onClick
      ),
    });
  }
}
export default ClickEventTrigger;
